"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaStepper = require("./AaStepper.model");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaHoverable = _interopRequireDefault(require("../../utils/airasia-hover/AaHoverable"));

var AaStepperButton = function AaStepperButton(props) {
  var buttonIcon = '';

  if (props.type === _AaStepper.STEPPER_BUTTON_TYPE.MINUS) {
    buttonIcon = '-';
  } else {
    buttonIcon = '+';
  }

  return /*#__PURE__*/_react["default"].createElement(_AaHoverable["default"], null, function (isHovered) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, (0, _extends2["default"])({
      accessibilityRole: "button",
      onPress: props.onPress,
      disabled: props.disabled,
      style: !props.disabled ? [defaultStyles.stepperButtonContainer, isHovered && defaultStyles.containerHover] : [defaultStyles.stepperButtonContainer, defaultStyles.disabled, isHovered && defaultStyles.containerDisableHover]
    }, props.accessibilityProps), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: [defaultStyles.stepperButtonText, buttonIcon === '-' ? {
        top: 2
      } : {
        top: 1
      }, isHovered ? {
        color: '#ffffff'
      } : {
        color: '#4b4fa6'
      }]
    }, buttonIcon));
  });
};

var defaultStyles = _StyleSheet["default"].create({
  stepperButtonContainer: {
    color: '#4b4fa6',
    borderWidth: 1,
    borderColor: '#4b4fa6',
    borderRadius: 4,
    width: 32,
    height: 32,
    alignContent: 'center'
  },
  containerHover: {
    backgroundColor: '#4b4fa6',
    web: {
      cursor: 'pointer'
    }
  },
  containerDisableHover: {
    backgroundColor: '#4b4fa6',
    web: {
      cursor: 'not-allowed'
    }
  },
  stepperButtonText: {
    fontSize: 20,
    color: '#4b4fa6',
    textAlign: 'center',
    position: 'relative'
  },
  disabled: {
    opacity: 0.5
  }
});

var _default = AaStepperButton;
exports["default"] = _default;